import logo from '../images/invertido_sem_fundo.png';
import '../styles/Home.css'

function HomePage() {
  return (
    <div className='container'>
      <header>
        <img src={logo} alt="Logo TBSoftwares" className="logoHome" /> 
      </header>
      <div className='slogan'>
          <h2>Soluções inteligentes para sua empresa</h2>
      </div>
    </div>
  );
}

export default HomePage;